import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {CookieService} from 'core/services/CookieService';
import {MODALS} from 'modules/modals/constants';
import {hideModal, showModal} from 'modules/modals/thunks';
import {useCallback, useMemo} from 'react';

const AGE_CONFIRM_COOKIE_NAME = 'age-confirm';

export const useAgeModal = () => {
    const dispatch = useAppDispatch();
    const cookieService = useMemo(() => CookieService.getInstance(), []);

    const handleAgeConfirm = useCallback(() => {
        cookieService.setInsecureCookie(AGE_CONFIRM_COOKIE_NAME, '1');
        dispatch(hideModal(MODALS.AGE_CONFIRM.name));
    }, [cookieService, dispatch]);

    const handleShowAgeConfirm = useCallback(() => {
        if (!cookieService.get(AGE_CONFIRM_COOKIE_NAME)) {
            dispatch(showModal(MODALS.AGE_CONFIRM.name));
        }
    }, [cookieService, dispatch]);

    return {
        handleAgeConfirm,
        handleShowAgeConfirm,
    };
};
